import React from 'react';
import ReactDOM from 'react-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faTimes, faCheckCircle, faCalendar, faEye, faAtom
} from '@fortawesome/free-solid-svg-icons';
import { categories } from './DiscoveriesData';
import './DiscoveryModal.css';

const DiscoveryModal = ({ discovery, onClose, isVisible }) => {
  if (!discovery) return null;

  const categoryInfo = categories.find(cat => cat.id === discovery.category);
  
  const modalContent = (
    <div 
      className={`OATS-discovery-modal-overlay ${isVisible ? 'OATS-discovery-modal-overlay--visible' : ''}`} 
      onClick={onClose}
    >
      <div 
        className={`OATS-discovery-modal ${isVisible ? 'OATS-discovery-modal--visible' : ''}`} 
        onClick={e => e.stopPropagation()}
      >
        {/* Header */}
        <div className="OATS-discovery-modal-header">
          <div className="OATS-discovery-modal-header-left">
            <div className="OATS-discovery-modal-icon">
              <FontAwesomeIcon icon={categoryInfo?.icon || faAtom} />
            </div>
            <div className="OATS-discovery-modal-title-section">
              <h2 className="OATS-discovery-modal-title">{discovery.title}</h2>
              <div className="OATS-discovery-modal-meta">
                <span className="OATS-discovery-modal-category">{discovery.category}</span>
                {discovery.verified && (
                  <span className="OATS-discovery-modal-verified">
                    <FontAwesomeIcon icon={faCheckCircle} />
                    Verified
                  </span>
                )}
              </div>
            </div>
          </div>
          <button className="OATS-discovery-modal-close" onClick={onClose}>
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>
        
        {/* Main Content */}
        <div className="OATS-discovery-modal-body">
          {/* Left Panel - Details */}
          <div className="OATS-discovery-modal-left">
                   <div className="OATS-discovery-modal-metrics">
              <h3>Key Metrics</h3>
              <div className="OATS-discovery-modal-metrics-grid">
                {Object.entries(discovery.metrics).map(([key, value]) => (
                  <div key={key} className="OATS-discovery-modal-metric-item">
                    <span className="OATS-discovery-modal-metric-value">{value}</span>
                    <span className="OATS-discovery-modal-metric-label">{key}</span>
                  </div>
                ))}
              </div>
            </div>
            
            <div className="OATS-discovery-modal-footer-info">
              <div className="OATS-discovery-modal-date">
                <FontAwesomeIcon icon={faCalendar} />
                {new Date(discovery.publishDate).toLocaleDateString()}
              </div>
              <div className="OATS-discovery-modal-read-time">
                <FontAwesomeIcon icon={faEye} />
                {discovery.readTime}
              </div>
            </div>
            
            <div className="OATS-discovery-modal-tags">
              {discovery.tags.map(tag => (
                <span key={tag} className="OATS-discovery-modal-tag">{tag}</span>
              ))}
            </div>
            <div className="OATS-discovery-modal-description">
              <p>{discovery.content}</p>
            </div>
            
     
          </div>

          {/* Right Panel - PDF Viewer (Future) */}
          <div className="OATS-discovery-modal-right">
            <div className="OATS-discovery-modal-pdf-placeholder">
              <div className="OATS-discovery-modal-pdf-icon">
                <FontAwesomeIcon icon={faAtom} />
              </div>
              <h3>PDF Viewer</h3>
              <p>Future PDF viewer will be displayed here</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  return ReactDOM.createPortal(modalContent, document.body);
};

export default DiscoveryModal;